import { render, staticRenderFns } from "./GroupPriceDetail.vue?vue&type=template&id=157e22ca&"
import script from "./GroupPriceDetail.vue?vue&type=script&lang=js&"
export * from "./GroupPriceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports